<script setup lang="ts">
/**
 * BG §18.4 — a webhook has its own vocabulary, but it takes the same five colours as everything else, and the kit
 * owns what those look like. This only maps each webhook word onto a kit status tone: processing is in flight,
 * accepted finished well, skipped is parked, and rejected and failed are both outcomes you cannot use. The pill
 * pulses only while the tone is running, so only processing pulses.
 */
import { type StatusTone, ZhStatusPill } from '@zerohuman/ui'
import { computed } from 'vue'
import type { WebhookStatus } from '@/api'

const props = defineProps<{ status: WebhookStatus }>()

const APPEARANCE: Record<WebhookStatus, { label: string; tone: StatusTone }> = {
    processing: { label: 'Processing', tone: 'running' },
    accepted: { label: 'Accepted', tone: 'completed' },
    skipped: { label: 'Skipped', tone: 'neutral' },
    rejected: { label: 'Rejected', tone: 'failed' },
    failed: { label: 'Failed', tone: 'failed' },
}

const appearance = computed(() => APPEARANCE[props.status])
</script>

<template>
    <ZhStatusPill :tone="appearance.tone" :data-webhook-status="status">{{ appearance.label }}</ZhStatusPill>
</template>
